class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      //console.log(this.parentElement.classList.contains('location__button'));
      if (!this.contains(document.activeElement) && !this.parentElement.classList.contains('menu-with-dropdown')) this.close();
      if (!this.contains(document.activeElement) && this.parentElement.classList.contains('menu-with-dropdown')){
        let self=this;
        let clickHandler=function(e){
          //console.log(self.contains(e.target));
          if(!self.contains(e.target)){
            self.close();
          }
        }
        document.body.removeEventListener('click',clickHandler);
        document.body.addEventListener('click',clickHandler);
      }

    });

  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
